module.exports = __webpack_public_path__ + "static/img/header-store-C.579c8b8.png";